var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0832 19.205L20.4863 28.8278C17.663 31.6587 16.2513 33.0742 14.5189 33.2306C14.2325 33.2566 13.9443 33.2566 13.6579 33.2306C11.9254 33.0742 10.5138 31.6587 7.6905 28.8278L4.49155 25.6202C2.72482 23.8486 2.72482 20.9764 4.49155 19.205M30.0832 19.205L17.2873 6.37438L30.0832 19.205ZM30.0832 19.205H4.49155H30.0832ZM17.2873 6.37438L4.49155 19.205L17.2873 6.37438ZM17.2873 6.37438L14.0884 3.16675L17.2873 6.37438Z",
    fill: "#2B634D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0832 19.205L20.4863 28.8278C17.663 31.6587 16.2513 33.0742 14.5189 33.2306C14.2325 33.2566 13.9443 33.2566 13.6579 33.2306C11.9254 33.0742 10.5138 31.6587 7.6905 28.8278L4.49155 25.6202C2.72482 23.8486 2.72482 20.9764 4.49155 19.205M30.0832 19.205L17.2873 6.37438M30.0832 19.205H4.49155M4.49155 19.205L17.2873 6.37438M17.2873 6.37438L14.0884 3.16675",
    stroke: "#2B634D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 31.6667C34.8333 33.4157 33.4156 34.8334 31.6667 34.8334C29.9177 34.8334 28.5 33.4157 28.5 31.6667C28.5 29.9178 31.6667 26.9167 31.6667 26.9167C31.6667 26.9167 34.8333 29.9178 34.8333 31.6667Z",
    fill: "#2B634D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/artwork.104cf73b0c50d3bff186b7d76acc09a9.svg";
export { ForwardRef as ReactComponent };